import PropTypes from 'prop-types';
import cx from 'classnames';
import BorderBottomDotted from '@app/components/common/BorderBottomDotted/BorderBottomDotted';

const SummaryOrderTotalsRow = ({
  extraLabelElement,
  extraValueElement,
  labelClasses,
  label,
  valueClasses,
  value
}) => {
  return (
    <tr>
      <td className="d-flex" data-testid="summary-order-totals">
        <p className={cx(...labelClasses)}>
          {label}
          {extraLabelElement}
        </p>
        <BorderBottomDotted />
        <p className={cx(...valueClasses)}>
          {extraValueElement}
          {value}
        </p>
      </td>
    </tr>
  );
};

SummaryOrderTotalsRow.propTypes = {
  extraLabelElement: PropTypes.element,
  extraValueElement: PropTypes.element,
  labelClasses: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
  ),
  label: PropTypes.string,
  valueClasses: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
  ),
  value: PropTypes.string
};

export default SummaryOrderTotalsRow;
